export default "__VITE_ASSET__o2fGZ6wU__"